const columns = [
  {
    name: 'Full Name',
    selector: (row) => row?.name_tx,
    sortable: true,
    sortField: 'name_tx',
  },
  {
    name: 'Send To local',
    selector: (row) => row?.sent_to_local,
    sortable: true,
    sortField: 'sent_to_local',
  },
  {
    name: 'Adjusted Score',
    selector: (row) => row?.score_adjusted,
    sortable: true,
    sortField: 'score_adjusted',
  },
  {
    name: 'Total',
    selector: (row) => row?.total,
    sortable: true,
    sortField: 'total',
  }, 
  
];
const mobileColumns = [
  {
    name: 'Full Name',
    selector: (row) => row?.name_tx,
    sortable: true,
    sortField: 'name_tx',
  },
  {
    name: 'Total',
    selector: (row) => row?.total,
    sortable: true,
    sortField: 'total',
  },
];

export { columns, mobileColumns };
